import { AxisBottom as VisxAxisBottom } from '@visx/axis';
import { tickLabelProps } from './styles';
import { useTranslation } from 'react-i18next';
import { ScaleLinear } from 'd3-scale';
import {
  MARGIN,
  STUNDEN_MAX,
} from '@/domain/dienstplan/shared/utils/constants';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { useStandort } from '@/domain/dienstplan/shared/hooks/useStandort/useStandort';
import { getOffsetFromTageswechsel } from '@/domain/dienstplan/shared/utils/getOffsetFromTageswechsel';

const createTickLabels = (offset: number) => {
  const labels: Record<number, string> = {};
  for (let i = 0; i <= 24; i++) {
    const hour = (i + offset) % 24;
    labels[i] = hour.toString().padStart(2, '0');
  }
  return labels;
};

export function AxisBottom({
  yMax,
  xScaleAxis,
}: {
  yMax: number;
  xScaleAxis: ScaleLinear<number, number, never>;
}) {
  const { t } = useTranslation();
  const bottomTickValues = Array.from({ length: STUNDEN_MAX + 1 }, (_, i) => i);
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { tageswechsel } = useStandort(standortId);
  const offset = getOffsetFromTageswechsel(tageswechsel);

  const tickLabels = createTickLabels(offset);

  return (
    <VisxAxisBottom
      hideTicks
      top={MARGIN.top + yMax}
      left={MARGIN.left}
      scale={xScaleAxis}
      tickValues={bottomTickValues}
      tickFormat={(i) => {
        const idx = Number(i);
        return tickLabels[idx];
      }}
      orientation="bottom"
      tickLabelProps={tickLabelProps}
      stroke="#E5E5EA"
      label={t('domain.dienstplan.mindestbelegung.visualEditor.labels.uhrzeit')}
      labelProps={{
        fontSize: 15,
        fontWeight: 600,
      }}
    />
  );
}
